export function serializer(string: string) {
  if (!string) {
    return '';
  }

  const normalized = string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const specialCaracs = /[!"`’'#%&,:;<>=@{}~$()*+/?[\]^|]+/gi;

  return normalized
    .toLowerCase()
    .replace(/ /g, '-') // remplace les espaces par des tirets
    .replace(specialCaracs, '') // supprime les caracteres speciaux
    .replace(/-+/g, '-') // remplace plusieurs tiret par un seul
    .replace(/^-+/, '') // Supprime les tirets au debut
    .replace(/-+$/, ''); // supprime les tirets a la fin
}
